import React, { useEffect }  from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'

import {
  Link  
} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: 'none',
    color: 'rgba(0,0,0,.6)',
    "&:hover": {
      color:'rgba(0,0,0,.8)',
    },
  },
  content:{
    display: 'flex',
    justifyItems: 'center',
  },  
  icon: {
    textAlign:'left',
    marginRight: 15,
  },
  label: {
    textAlign:'left',
  },
  
}));

export default function ItemMenuRight(props) {

  const {url, icon, label, eventToClick} = props
  const classes = useStyles();  

  let eventLink = {}
  if(url){
    eventLink =  <Link className={classes.link}  to={url}>
                    <MenuItem>
                      <div className={classes.content} >
                        <div className={classes.icon}  >{icon}</div> 
                        <div className={classes.label}  >{label}</div>
                      </div>
                    </MenuItem>
                  </Link>
  } else (
    eventLink = <Link className={classes.link}  onClick={eventToClick} >
                  <MenuItem>
                    <div className={classes.content} >
                      <div className={classes.icon}  >{icon}</div> 
                      <div className={classes.label}  >{label} </div>
                    </div>
                  </MenuItem>
                </Link>     
  )

  useEffect(() => {      
    
  }, [])

  return(eventLink)
}